var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterproofIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.471,
    height: 41.717,
    viewBox: "0 0 41.471 41.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "waterproof",
    transform: "translate(-10.236 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11858",
    "data-name": "Path 11858",
    d: "M42.043,36.2a8.7,8.7,0,0,0,8.67-8.67c.007-2.955-2.089-6.2-4.3-9.633A44.3,44.3,0,0,1,42.043,10a44.324,44.324,0,0,1-4.372,7.9c-2.208,3.432-4.305,6.678-4.3,9.633A8.7,8.7,0,0,0,42.043,36.2Zm-6.3-9.64h.007a.748.748,0,0,1,.746.746,5.59,5.59,0,0,0,5.574,5.581.746.746,0,1,1,0,1.492,7.085,7.085,0,0,1-7.066-7.066A.744.744,0,0,1,35.746,26.564Z",
    transform: "translate(-11.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11859",
    "data-name": "Path 11859",
    d: "M51.707,54.658l-11-5.567a10.139,10.139,0,0,1-19.474,0l-11,5.567L30.971,65.163Z",
    transform: "translate(0 -18.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11860",
    "data-name": "Path 11860",
    d: "M31.307,74.955a.73.73,0,0,1-.672,0L13.78,66.419,10.236,68.21,30.971,78.716,51.707,68.21l-3.544-1.791Z",
    transform: "translate(0 -26.999)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterproofIcon);
export default __webpack_public_path__ + "static/media/waterproof_icon.0af32d87bc1d2ce3c679ee134225acdc.svg";
export { ForwardRef as ReactComponent };